import React from 'react'
import { Box, Typography } from '@mui/material'
import { PersonIcon, UserIcon, Edit, Trash } from '@/shared/ui/Icons'
import { Profile } from '@/shared/store/useAppStore'

interface ProfilesListProps {
    profiles: Profile[]
    actualProfileId?: string | null
    onEditProfile: (profile: Profile) => void
    onDeleteProfile: (profile: Profile) => void
    onSelectProfile: (profile: Profile) => void
}

const userContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '10px',

    width: '100%',
}

const userContainerStyleChecked = {
    ...userContainerStyle,
    bgcolor: 'black',
}

const profileRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
}

const userNameStyle = {
    typography: 'text2',
    lineHeight: '17px',
    height: '17px',
    color: 'custom.greyFontColor',
    paddingLeft: '12px',
}

const ProfilesList: React.FC<ProfilesListProps> = ({
    profiles,
    actualProfileId,
    onEditProfile,
    onDeleteProfile,
    onSelectProfile,
}) => {
    const icon = (isKid: boolean) => (isKid ? <UserIcon /> : <PersonIcon />)
    const containerStyle = (profileId: string) =>
        actualProfileId === profileId
            ? userContainerStyleChecked
            : userContainerStyle
    return (
        <>
            {profiles.map((profile) => (
                <Box key={profile.id} sx={profileRowStyle}>
                    <Box
                        sx={containerStyle(profile.id)}
                        onClick={() => onSelectProfile(profile)}>
                        {icon(profile.isKid)}
                        <Typography sx={userNameStyle}>
                            {profile.profile_name}
                        </Typography>
                    </Box>
                    <Box
                        sx={{ cursor: 'pointer' }}
                        onClick={() => onEditProfile(profile)}>
                        <Edit fill="#fff" height="30px" width="30px" />
                    </Box>
                    <Box
                        sx={{ cursor: 'pointer' }}
                        onClick={() => onDeleteProfile(profile)}>
                        <Trash fill="#fff" height="30px" width="30px" />
                    </Box>
                </Box>
            ))}
        </>
    )
}

export default ProfilesList
